import { Pipe, PipeTransform } from "@angular/core";
import { CommentTargetType } from "@webapp/comments";
import { ReflectionNoteType, checkinTargetTypesRecord } from "../models/reflections.models";

@Pipe({ name: "checkinsTargetType" })
export class CheckinsTargetTypePipe implements PipeTransform {
  public transform(type: ReflectionNoteType): CommentTargetType {
    return checkinTargetTypesRecord[type];
  }
}
